<template>
  <product-card :product="product" :image="image" :module="module">
    <div class="l-col-6@md" slot="attributes">
      <div class="margin">
        <strong>{{ $t('color.label') }}</strong>
        {{ product.color }}
      </div>
    </div>
    <div class="l-col-6@md" slot="attributes">
      <div class="margin">
        <strong>{{ $t(`netshoes.gridType.${product.gridType}.label`) }}</strong>
        {{ product.grid }}
      </div>
    </div>
  </product-card>
</template>

<script>
  import ProductCard from '@/components/marketplace/shared/ProductCard'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      },
      module: {
        type: Object,
        required: true
      }
    },
    computed: {
      image () {
        if (!this.product.images.length) {
          return ''
        }

        return this.product.images[0].url
      }
    },
    components: {
      ProductCard
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px
</style>



// WEBPACK FOOTER //
// ProductCard.vue?d227b1b2